import React, { useEffect, useRef } from "react"

import TokenList from "decentraland-gatsby/dist/utils/dom/TokenList"

import "./Video.css"

export type VideProps = React.HTMLProps<HTMLVideoElement> & { play?: boolean }

export default function Video(props: VideProps) {
  const ref = useRef<HTMLVideoElement>(null)
  useEffect(() => {
    if (!ref.current || typeof props.play !== "boolean") {
      return
    }

    if (props.play && ref.current.paused) {
      ref.current.play()
    } else if (!props.play && !ref.current.paused) {
      ref.current.pause()
    }
  }, [ref.current, props.play])
  return (
    <video
      {...props}
      ref={ref}
      className={TokenList.join(["Video", props.className])}
    />
  )
}
